<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz powód pominięcia.
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="reportOutOfSequenceCodeId"
                                :items="reportOutOfSequenceCodes"
                                item-value="id"
                                item-text="name"
                                outlined
                                no-data-text="Nie znaleziono kodu"
                                label="Kod"
                                required
                                dense
                                :error-messages="reportOutOfSequenceCodeIdErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zamknij"
                    @click="onSave()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ReportOutOfSequenceDialog',
    props: {
        isOpen: {
            type: Boolean
        }
    },
    data() {
        return {
            reportOutOfSequenceCodeId: null,
            actionLoading: false,
        }
    },
    validations: {
        reportOutOfSequenceCodeId: {
            required
        },
    },
    computed: {
        reportOutOfSequenceCodes() {
            return this.$store.state.reports.reporting.reportOutOfSequenceCodes
        },
        reportOutOfSequenceCodeIdErrors() {
            const errors = []

            if (!this.$v.reportOutOfSequenceCodeId.$dirty) return errors
            !this.$v.reportOutOfSequenceCodeId.required && errors.push('Proszę wybrać kod.')

            return errors
        },
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.reportOutOfSequenceCodeId)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
            this.$v.$reset()
            setTimeout(() => {
                this.reportOutOfSequenceCodeId = null
            }, 500)
        },
    }
}
</script>

